import { QuickAddComponent } from '@theme/quick-add';

class UpsellQuickAddComponent extends QuickAddComponent {
  get productPageUrl() {
    const url = this.dataset.productUrl || '';
    return url;
  }
}

try {
  if (!customElements.get('upsell-quick-add-component')) {
    customElements.define('upsell-quick-add-component', UpsellQuickAddComponent);
  }
} catch {
  // If the browser/customElements isn't ready for any reason, fail silently.
}

